import { currentReleaseInfo, type ReleaseInfo } from '../lib/releaseInfo'

export function ReleaseEnvironmentBanner({ info = currentReleaseInfo(), groups = false }: { info?: ReleaseInfo; groups?: boolean }) {
  const actionsLabel = groups ? 'Groups messages use preview and confirmation controls' : info.customerActions === 'enabled'
    ? 'Customer actions are available'
    : 'Customer actions are safely switched off'
  const detail = `${info.label} · Release ${info.release} · Built ${info.releasedAtLabel} · ${actionsLabel}`
  const environmentClass = info.isProduction
    ? 'border-emerald-300 bg-emerald-50 text-emerald-950'
    : info.environment === 'local'
      ? 'border-sky-300 bg-sky-50 text-sky-950'
      : 'border-amber-400 bg-amber-100 text-amber-950'

  return (
    <aside
      data-testid="release-environment"
      data-environment={info.environment}
      data-customer-actions={groups ? 'individual-controls' : info.customerActions}
      className={`relative z-[120] flex min-h-8 flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b px-3 py-1.5 text-center text-[11px] font-semibold leading-4 shadow-sm sm:text-xs ${environmentClass}`}
      aria-label={`Release state: ${detail}`}
    >
      <span className="font-bold uppercase tracking-[0.1em]">{info.label}</span>
      <span>Release <span className="font-mono">{info.release}</span></span>
      <span>Built <time dateTime={info.releasedAt || undefined}>{info.releasedAtLabel}</time></span>
      <span>{actionsLabel}{groups || info.customerActionsConfigured ? '' : ' because no release setting was supplied'}</span>
    </aside>
  )
}
